function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M441.9,316.91c0,37.44-5.11,65-14.92,85.38H69.55c-10.08-20.64-15.45-48.74-15.45-87,0-142.69,73.72-274.91,192.09-274.91S441.9,174.22,441.9,316.91Z",
    style: {
      fill: "#00FF00",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.9,316.91c0,37.44-5.11,65-14.92,85.38H69.55c-10.08-20.64-15.45-48.74-15.45-87,0-142.69,73.72-274.91,192.09-274.91S441.9,174.22,441.9,316.91Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-20"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 172.18,
    y: 137.1,
    width: 151.64,
    height: 191.31,
    rx: 16.14,
    style: {
      fill: "#bfbfbf",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.28,
    y: 144.69,
    width: 128.42,
    height: 162.01,
    rx: 10.69,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.28,
    y: 144.69,
    width: 128.42,
    height: 162.01,
    rx: 10.69,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.08,168.66a1,1,0,0,0-1.22.7l-.51,2.47-7.76-1.24a1.05,1.05,0,0,0-1.14.72l-1,3.63a.87.87,0,0,0,.61,1.15,1,1,0,0,0,1.21-.71l.75-2.76,1.68.26-1.36,4.9h0l-2.4,8.5a.87.87,0,0,0,.66,1.12.94.94,0,0,0,.55-.06,1.05,1.05,0,0,0,.63-.7l2.08-7.34h0l.06-.21a1,1,0,0,1,1.09-.78h0l1.57.3L205,181.83a.92.92,0,0,0,.12,1.33,1,1,0,0,0,1.35-.23l3.52-4.45a1,1,0,0,0,.18-.91.84.84,0,0,0-.66-.58l-1.41-.27.78-3.16,1.86.29a.92.92,0,0,0,.52-.06,1,1,0,0,0,.62-.66l.79-3.32A.87.87,0,0,0,212.08,168.66Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.16,170.72a2,2,0,0,0,1.23-2.45,1.74,1.74,0,0,0-2.37-1,2,2,0,0,0-1.22,2.45A1.73,1.73,0,0,0,208.16,170.72Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 205.99,
    cy: 176.9,
    r: 15.24,
    style: {
      fill: "none",
      stroke: "#999",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206,192.15a15.25,15.25,0,1,1,15.24-15.25",
    style: {
      fill: "none",
      stroke: "#00FF00",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.26,213.71a.36.36,0,0,1-.27-.12l-2.61-2.91a.36.36,0,1,1,.54-.49l2.61,2.91a.36.36,0,0,1,0,.51A.33.33,0,0,1,271.26,213.71Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.2,204.93v-.46h-1.49V205a6,6,0,0,0,.86,11.87,6,6,0,0,0,.63-11.9Zm-.63,11.17a5.24,5.24,0,1,1,5.23-5.24A5.25,5.25,0,0,1,268.57,216.1Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.47,
    y: 203.26,
    width: 1.98,
    height: 1.01,
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M271.26,213.71a.36.36,0,0,1-.27-.12l-2.61-2.91a.36.36,0,1,1,.54-.49l2.61,2.91a.36.36,0,0,1,0,.51A.33.33,0,0,1,271.26,213.71Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.2,204.93v-.46h-1.49V205a6,6,0,0,0,.86,11.87,6,6,0,0,0,.63-11.9Zm-.63,11.17a5.24,5.24,0,1,1,5.23-5.24A5.25,5.25,0,0,1,268.57,216.1Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.47,
    y: 203.26,
    width: 1.98,
    height: 1.01,
    style: {
      fill: "#00FF00"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M194.06,274.42c-.92,0-1.5.5-1.5,1.82v2h-2.72v-1.78c0-2.94,1.47-4.62,4.3-4.62s4.3,1.68,4.3,4.62c0,5.77-5.74,7.93-5.74,10.94a2.61,2.61,0,0,0,0,.4h5.46v2.62h-8.34v-2.25c0-5.41,5.72-6.3,5.72-11.61C195.56,274.87,195,274.42,194.06,274.42Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.54,284.42,204.79,272h3.15v12.41h1.37v2.63h-1.37v3.33h-2.83v-3.33h-5.57Zm5.57,0v-6.9l-2.92,6.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.22,284.45v1.71c0,1.31.57,1.78,1.49,1.78s1.5-.47,1.5-1.78v-4.05c0-1.31-.58-1.81-1.5-1.81s-1.49.5-1.49,1.81v.56h-2.73L211,272h7.61v2.62h-5l-.24,4.39a2.76,2.76,0,0,1,2.52-1.34c2.13,0,3.2,1.49,3.2,4.2V286c0,2.94-1.47,4.62-4.3,4.62s-4.3-1.68-4.3-4.62v-1.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.56,280h-1.27l-.22-1.45h-1.55l-.21,1.45h-1.16l1.28-8h1.84Zm-2.88-2.54h1.22l-.61-4.05Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.79,277.05v1.06c0,1.28-.64,2-1.88,2s-1.87-.74-1.87-2v-4.17c0-1.28.64-2,1.87-2a1.75,1.75,0,0,1,1.88,2v.78H228.6v-.86c0-.57-.25-.78-.65-.78s-.66.21-.66.78v4.33c0,.57.26.78.66.78s.65-.21.65-.78v-1.14Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.19,272h3.89v1.15h-1.32V280H231.5v-6.86h-1.31Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.62,272h1.26v8h-1.26Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.7,278.56l1-6.54h1.15l-1.23,8H237.7l-1.23-8h1.27Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.65,275.4h1.73v1.14h-1.73v2.35h2.18V280H241.4v-8h3.43v1.15h-2.18Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.13,287.53v1.06c0,1.29-.64,2-1.87,2s-1.88-.73-1.88-2v-4.16a1.75,1.75,0,0,1,1.88-2c1.23,0,1.87.73,1.87,2v.78h-1.19v-.86c0-.57-.25-.79-.65-.79s-.65.22-.65.79v4.32c0,.58.25.78.65.78s.65-.2.65-.78v-1.14Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230,290.52H228.7l-.22-1.46h-1.54l-.22,1.46h-1.15l1.28-8h1.84ZM227.1,288h1.21l-.6-4.05Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.55,282.51h1.26v6.86h2.07v1.15h-3.33Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.67,234.26l1.21-.07a35.83,35.83,0,0,1-4.28,3.54l-1.11.72h0l-1.08-.79a27.1,27.1,0,0,1-3.35-3.34l1.56.09.92-2.27,1.36,4.8,1.27-2.71.8,1.51.93-2.64.8,2.58Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.47,233.07h-1.89l-.59.86-1.14-2.83-1,2.76-.75-1.43-1,1.95-1.57-4.95L251.35,233h-2.11c-1.29-1.47-1.73-2.92-.06-4.2,2.1-1.61,4.52-.11,5.75.86,1.29-.9,4.13-2.75,6.31-.35C262.33,230.56,261.67,231.87,260.47,233.07Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.53,224.36c2.23,0,2.73-.94,3.18-2h1.94v16.15h-2.89V226.16h-2.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.36,224.45c-.91,0-1.49.44-1.49,1.6v1.73h-2.73v-1.57c0-2.59,1.47-4.06,4.3-4.06s4.31,1.47,4.31,4.06c0,5.07-5.75,7-5.75,9.62a1.31,1.31,0,0,0,0,.34h5.45v2.31h-8.34v-2c0-4.76,5.72-5.54,5.72-10.2C203.86,224.85,203.28,224.45,202.36,224.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.75,224.45c-.91,0-1.49.44-1.49,1.6v1.73h-2.73v-1.57c0-2.59,1.47-4.06,4.3-4.06s4.31,1.47,4.31,4.06c0,5.07-5.75,7-5.75,9.62a1.31,1.31,0,0,0,0,.34h5.46v2.31h-8.35v-2c0-4.76,5.72-5.54,5.72-10.2C214.25,224.85,213.67,224.45,212.75,224.45Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.9,228.51V229a2.5,2.5,0,0,1-1.5,2.61,2.58,2.58,0,0,1,1.73,2.77v1c0,2-1.2,3.08-3.52,3.08H220v-13h3.5C225.87,225.54,226.9,226.52,226.9,228.51Zm-4.61-1.12v3.42h.9c.87,0,1.39-.33,1.39-1.37v-.72c0-.93-.36-1.33-1.18-1.33Zm0,5.27v4h1.32c.78,0,1.2-.32,1.2-1.28v-1.13c0-1.2-.44-1.57-1.49-1.57Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.38,228.74v1.68c0,2.07-1.14,3.2-3.46,3.2h-1.09v4.87h-2.31v-13h3.4C234.24,225.54,235.38,226.67,235.38,228.74Zm-4.55-1.35v4.38h1.09c.74,0,1.14-.3,1.14-1.22v-1.94c0-.93-.4-1.22-1.14-1.22Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.46,234.73l1.57-9.19h3.22v13h-2.19V229.2l-1.6,9.29h-2.18l-1.73-9.16v9.16h-2v-13h3.22Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,251.7c0-1.66-.57-2.1-1.49-2.1s-1.5.5-1.5,1.81v1.18h-2.73v-1c0-2.94,1.47-4.62,4.31-4.62s4.3,1.68,4.3,4.62v.48c0,2-.63,3.2-2,3.77,1.44.63,2,2,2,3.86v1.45c0,2.94-1.47,4.62-4.3,4.62s-4.31-1.68-4.31-4.62v-1.53H192v1.71c0,1.31.58,1.81,1.5,1.81s1.49-.44,1.49-2.07v-1.45c0-1.7-.57-2.33-1.89-2.33h-1v-2.63h1.13c1.08,0,1.73-.47,1.73-1.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.65,249.49a2.85,2.85,0,0,0,3.17-2.31h1.94v18.38h-2.88v-14h-2.23Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212,249.49a2.85,2.85,0,0,0,3.17-2.31h1.94v18.38h-2.88v-14H212Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.88,247h3.89v1.14h-1.31v6.87H222.2v-6.87h-1.32Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.22,249a1.91,1.91,0,1,1,3.82,0v4.17a1.91,1.91,0,1,1-3.82,0Zm1.25,4.25c0,.57.26.79.66.79s.65-.22.65-.79v-4.33c0-.57-.25-.79-.65-.79s-.66.22-.66.79Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.48,247h3.89v1.14h-1.31v6.87H230.8v-6.87h-1.32Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.56,255.05h-1.27l-.22-1.45h-1.54l-.22,1.45h-1.16l1.28-8h1.85Zm-2.87-2.54h1.21l-.61-4Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.14,247h1.26v6.87h2.07v1.14h-3.33Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.9,262.55v1.06c0,1.28-.64,2-1.88,2s-1.88-.74-1.88-2v-4.16c0-1.28.64-2,1.88-2s1.88.74,1.88,2v.77h-1.19v-.85c0-.58-.25-.79-.66-.79s-.65.21-.65.79v4.32c0,.57.25.78.65.78s.66-.21.66-.78v-1.14Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.73,265.54h-1.27l-.21-1.46H226.7l-.22,1.46h-1.15l1.28-8h1.84ZM226.86,263h1.22l-.61-4.05Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.32,257.52h1.26v6.87h2.07v1.15h-3.33Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.14,202.75c0-2.94,1.55-4.62,4.38-4.62s4.39,1.68,4.39,4.62v9.55c0,2.94-1.55,4.62-4.39,4.62s-4.38-1.68-4.38-4.62Zm2.89,9.74c0,1.31.57,1.81,1.49,1.81s1.5-.5,1.5-1.81v-9.92c0-1.32-.58-1.81-1.5-1.81s-1.49.49-1.49,1.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.58,202.91c0-3.1,1.42-4.78,4.41-4.78,2.84,0,4.31,1.68,4.31,4.62v.47h-2.73v-.65c0-1.32-.58-1.81-1.5-1.81s-1.6.49-1.6,2.25v3.36a2.75,2.75,0,0,1,2.68-1.63c2.12,0,3.2,1.5,3.2,4.2v3.36c0,2.94-1.55,4.62-4.38,4.62s-4.39-1.68-4.39-4.62Zm2.89,6.27v3.31c0,1.31.58,1.78,1.5,1.78s1.49-.47,1.49-1.78v-3.31c0-1.31-.58-1.81-1.49-1.81S202.47,207.87,202.47,209.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.94,213.93v2.78h-2.78v-2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.8,202.75c0-2.94,1.55-4.62,4.38-4.62s4.39,1.68,4.39,4.62v9.55c0,2.94-1.55,4.62-4.39,4.62s-4.38-1.68-4.38-4.62Zm2.89,9.74c0,1.31.58,1.81,1.49,1.81s1.5-.5,1.5-1.81v-9.92c0-1.32-.58-1.81-1.5-1.81s-1.49.49-1.49,1.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.91,198.34v2.52l-4.26,15.85h-2.88L231,201h-5.74v-2.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,213.93v2.78h-2.78v-2.78Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.48,200.65a2.86,2.86,0,0,0,3.18-2.31h1.94v18.37h-2.88v-14h-2.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.24,216.92c-2.92,0-4.52-1.68-4.52-4.62v-1.44c0-1.76.53-3.12,1.79-3.83-1.21-.66-1.79-1.89-1.79-3.7v-.58c0-2.94,1.6-4.62,4.52-4.62s4.51,1.68,4.51,4.62v.58c0,1.81-.6,3-1.78,3.7,1.26.71,1.78,2.07,1.78,3.83v1.44C259.75,215.24,258.15,216.92,255.24,216.92Zm-1.63-13c0,1.47.68,1.94,1.63,1.94s1.63-.47,1.63-1.94v-1c0-1.65-.71-2.09-1.63-2.09s-1.63.44-1.63,2.09Zm1.63,10.42c.92,0,1.6-.45,1.63-2.08v-1.7c0-1.44-.61-2.07-1.63-2.07s-1.63.63-1.63,2.07v1.7C253.61,213.85,254.32,214.3,255.24,214.3Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.88,171.54a2.4,2.4,0,0,1-2.62-2.68V168a2.35,2.35,0,0,1,1-2.23,2.19,2.19,0,0,1-1-2.15v-.33a2.62,2.62,0,1,1,5.24,0v.33a2.24,2.24,0,0,1-1,2.15,2.36,2.36,0,0,1,1,2.23v.84A2.4,2.4,0,0,1,281.88,171.54Zm-.94-7.58c0,.86.39,1.13.94,1.13s.95-.27.95-1.13v-.59c0-1-.41-1.22-.95-1.22s-.94.26-.94,1.22Zm.94,6.06c.54,0,.93-.26.95-1.21v-1c0-.84-.35-1.2-.95-1.2s-.94.36-.94,1.2v1C280.94,169.76,281.35,170,281.88,170Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.13,164v1.62h-1.62V164Zm0,5.81v1.62h-1.62V169.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.8,162.15c-.53,0-.87.29-.87,1v1.15h-1.58v-1c0-1.71.85-2.68,2.5-2.68s2.5,1,2.5,2.68c0,3.35-3.34,4.6-3.34,6.36a1.62,1.62,0,0,0,0,.22h3.18v1.53h-4.85v-1.31c0-3.14,3.32-3.66,3.32-6.74C291.67,162.41,291.34,162.15,290.8,162.15Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.62,163.37c0-1-.34-1.22-.87-1.22s-.87.29-.87,1v.69H294.3v-.58c0-1.71.85-2.68,2.5-2.68s2.5,1,2.5,2.68v.27a2.08,2.08,0,0,1-1.18,2.2A2.17,2.17,0,0,1,299.3,168v.84c0,1.7-.86,2.68-2.5,2.68s-2.5-1-2.5-2.68V168h1.58v1c0,.77.34,1.06.87,1.06s.87-.26.87-1.21V168c0-1-.34-1.35-1.1-1.35H296v-1.53h.65c.63,0,1-.27,1-1.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.73,174.29c1.63,0,2.47.7,2.47,1.94v.24h-1.59v-.32c0-.55-.3-.76-.84-.76s-.83.21-.83.76c0,1.6,3.27,1.89,3.27,4.1,0,1.24-.85,1.95-2.5,1.95s-2.5-.71-2.5-1.95v-.47h1.59v.55c0,.55.33.75.87.75s.87-.2.87-.75c0-1.59-3.28-1.89-3.28-4.1C279.26,175,280.1,174.29,281.73,174.29Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.78,174.38v6c0,.55.33.75.87.75s.86-.2.86-.75v-6h1.59v5.88c0,1.24-.85,2-2.5,2s-2.5-.71-2.5-2v-5.88Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.74,176.51v5.6h-1.51v-7.73h2.1l1.73,4.62v-4.62h1.49v7.73h-1.72Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.1,299.71a1.61,1.61,0,1,1-1.61-1.6A1.61,1.61,0,0,1,240.1,299.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.6,299.71a1.6,1.6,0,1,1-1.6-1.6A1.6,1.6,0,0,1,249.6,299.71Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.11,299.71a1.61,1.61,0,1,1-1.61-1.6A1.61,1.61,0,0,1,259.11,299.71Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Clouds--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339.77,134.34h58.48a2.37,2.37,0,0,0,1.69-4.05,7.22,7.22,0,0,0-3.53-1.64,2.34,2.34,0,0,1-1.79-1.91c-.68-4-3.37-14.11-13.45-14.32a15.91,15.91,0,0,0-15,8.74,2.39,2.39,0,0,1-2.92,1.16c-1.89-.68-4.8-.83-7.17,3a2.4,2.4,0,0,1-2.72,1.07,7.29,7.29,0,0,0-8.27,2.41,2.29,2.29,0,0,1-2.09.91,19.86,19.86,0,0,0-3.36-.15C336.55,129.72,336.71,134.34,339.77,134.34Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.78,128.88H175c3.26,0,5-4,2.62-6.24a11.4,11.4,0,0,0-5.44-2.53,3.6,3.6,0,0,1-2.77-2.94c-1-6.26-5.2-21.77-20.75-22.09-13.92-.28-20.54,8.46-23.18,13.48a3.69,3.69,0,0,1-4.51,1.79c-2.91-1-7.4-1.27-11.06,4.66a3.7,3.7,0,0,1-4.19,1.64c-3.26-1-8.74-1.47-12.76,3.72a3.53,3.53,0,0,1-3.23,1.41,30.67,30.67,0,0,0-5.17-.23C79.8,121.77,80.05,128.88,84.78,128.88Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.68,432.44c-22.67,21-141.48,26.9-156.49,26.9-15.88,0-122.34-3.57-153.12-26.95l-.16-.14,106-30h96.86Z",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 350.59,
    y1: 436.98,
    x2: 276.22,
    y2: 402.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 372.07,
    y1: 447,
    x2: 354.1,
    y2: 438.62,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 266.73,
    y1: 415.33,
    x2: 257.41,
    y2: 402.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 289.36,
    y1: 447,
    x2: 268.9,
    y2: 418.36,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 215.06,
    y1: 435.22,
    x2: 238.59,
    y2: 402.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.64,
    y1: 447,
    x2: 212.04,
    y2: 439.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 189.97,
    y1: 416.19,
    x2: 219.77,
    y2: 402.29,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.93,
    y1: 447,
    x2: 184.4,
    y2: 418.79,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "42.5 446.5 92.91 432.25 198.93 402.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "454.78 402.29 426.98 402.29 426.58 402.29 384.95 402.29 379.98 402.29 295.79 402.29 295.64 402.29 295.05 402.29 276.24 402.29 257.41 402.29 238.59 402.29 219.77 402.29 200.96 402.29 198.93 402.29 69.55 402.29 69.45 402.29 41.22 402.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "295.79 402.29 402.68 432.44 458.9 448.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Trees--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M419.6,383.35s17.64-1.27,26.44-18c9.5-18.09-13.67-61-25.51-64.18-13-3.5-33.52,30.78-29.32,57.43C394.09,376.76,411.45,382.88,419.6,383.35Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.6,383.35s17.64-1.27,26.44-18c9.5-18.09-13.67-61-25.51-64.18-13-3.5-33.52,30.78-29.32,57.43C394.09,376.76,411.45,382.88,419.6,383.35Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M431.92,352.58l-11.29,12.36c0,.43,0,.85,0,1.28.08,5.52.19,11.23.28,17,0,.37,0,.75,0,1.12.06,4.49.27,14.07.34,18.64a2.51,2.51,0,0,1-2.5,2.55h0a2.51,2.51,0,0,1-2.54-2.58l.44-18.64,0-1.27.06-2.08.07-3.11-14.47-15.74c1.16,0-.92-2.18-1.13-2.39L417,372.06l.63-26.94-9.49-10.33c.82,0-.66-1.54-.81-1.7l10.39,8.18v-.51l.57-23.42,1.56,1.71s.31,18.32.7,41.27l12.28-9.77C432.66,350.74,431,352.59,431.92,352.58Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,383.24a12.47,12.47,0,0,0,3-.13c5.12-.87,19.88-5.26,35.91-27.6,17.38-24.23-15.61-99.24-34.1-116.49S38,316,42.14,339.87C48,373.07,72.53,382,87.65,383.24Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.65,383.24a12.47,12.47,0,0,0,3-.13c5.12-.87,19.88-5.26,35.91-27.6,17.38-24.23-15.61-99.24-34.1-116.49S38,316,42.14,339.87C48,373.07,72.53,382,87.65,383.24Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.83,333.86,94.22,361.31l2.6,65.28a4.47,4.47,0,0,1-4.46,4.65h0a4.45,4.45,0,0,1-4.46-4.47c0-13.22.3-54.08.55-100.38l-21.17-20.3c1.61,0-1.27-2.74-1.55-3L88.5,318.92c.18-35.11.35-63.39.35-63.39L90.92,253l1.15,37.55,19.52-14.05c-.29.27-3.17,3-1.56,3L92.27,297.13l1.66,54.1,30.12-21.69C123.65,329.93,119.52,333.86,121.83,333.86Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Graphics--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248,388.65c-79.55,0-144.27-64.72-144.27-144.27S168.45,100.1,248,100.1s144.27,64.72,144.27,144.28S327.55,388.65,248,388.65Zm0-279.55c-74.59,0-135.27,60.69-135.27,135.28S173.41,379.65,248,379.65,383.27,319,383.27,244.38,322.59,109.1,248,109.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248,388.65c-79.55,0-144.27-64.72-144.27-144.27S168.45,100.1,248,100.1s144.27,64.72,144.27,144.28a4.5,4.5,0,0,1-9,0c0-74.59-60.68-135.28-135.27-135.28S112.73,169.79,112.73,244.38,173.41,379.65,248,379.65a4.5,4.5,0,0,1,0,9Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,53.56a11.52,11.52,0,0,0-11.52,11.51c0,4,4.67,12.31,8.06,17.77C242.44,86,244,88.18,244,88.18s1.52-2.22,3.44-5.34c3.4-5.46,8.06-13.73,8.06-17.77A11.52,11.52,0,0,0,244,53.56Zm0,17.18a5.24,5.24,0,1,1,5.24-5.24A5.23,5.23,0,0,1,244,70.74Z",
    style: {
      fill: "#00FF00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.94,61a9,9,0,0,0-9,9c0,3.18,3.66,9.67,6.33,14,1.52,2.46,2.71,4.2,2.71,4.2s1.2-1.74,2.71-4.2c2.66-4.29,6.33-10.78,6.33-14A9,9,0,0,0,222.94,61Zm0,13.49a4.12,4.12,0,1,1,4.12-4.12A4.11,4.11,0,0,1,222.94,74.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.92,89h0l-4.68,0a.6.6,0,0,1-.57-.62.66.66,0,0,1,.58-.61l4.68,0a.62.62,0,0,1,0,1.23Zm-8.19-.06h-4.68a.59.59,0,0,1-.57-.61.59.59,0,0,1,.57-.62h4.68a.6.6,0,0,1,.57.62A.59.59,0,0,1,235.73,88.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.64,88.89H223a.59.59,0,0,1-.58-.61.6.6,0,0,1,.58-.62h4.68a.6.6,0,0,1,.57.62A.59.59,0,0,1,227.64,88.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.67,56.92c-1,0-1.68.56-1.68,2v2.22h-3.07v-2c0-3.3,1.65-5.19,4.84-5.19s4.83,1.89,4.83,5.19c0,6.49-6.46,8.91-6.46,12.3a2.17,2.17,0,0,0,0,.44h6.14v2.95h-9.38V72.32c0-6.08,6.43-7.08,6.43-13C266.35,57.42,265.7,56.92,264.67,56.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.85,59.28c0-1.86-.65-2.36-1.68-2.36s-1.68.56-1.68,2v1.33h-3.07V59.16c0-3.3,1.65-5.19,4.84-5.19s4.84,1.89,4.84,5.19v.53c0,2.21-.71,3.6-2.27,4.25,1.62.71,2.27,2.24,2.27,4.33V69.9c0,3.3-1.66,5.19-4.84,5.19s-4.84-1.89-4.84-5.19V68.19h3.07V70.1c0,1.48.65,2,1.68,2s1.68-.5,1.68-2.33V68.19c0-1.92-.65-2.63-2.12-2.63h-1.09v-3h1.27c1.2,0,1.94-.53,1.94-2.18Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.57,85.37l.89-5.91h1.82v8.33h-1.23v-6l-.91,6H261.9l-1-5.89v5.89h-1.14V79.46h1.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.24,79.46h1.31v8.33h-1.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.5,79.46h1.31V86.6H272v1.19H268.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.85,83h1.79v1.19h-1.79V86.6h2.26v1.19h-3.57V79.46h3.57v1.19h-2.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.68,79.36c1.27,0,1.93.77,1.93,2.1v.26h-1.24v-.35c0-.59-.24-.82-.65-.82s-.66.23-.66.82c0,1.72,2.56,2,2.56,4.42a1.82,1.82,0,0,1-1.95,2.09c-1.29,0-1.95-.76-1.95-2.09v-.51H278v.59c0,.6.26.81.67.81s.68-.21.68-.81c0-1.71-2.56-2-2.56-4.41C276.75,80.13,277.41,79.36,278.68,79.36Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.47,420.61a5,5,0,0,0-3.29,5.35c.25,4.28-4.39,16.05.28,18.65,5.3,2.95,14.36,2.73,15.06.19s-2.16-6.54-1.9-9.68,2.64-13.45-1.17-14.39S258.47,420.61,258.47,420.61Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.5,423.26a3.19,3.19,0,0,1,1,2c.3,2.36,1-3.21,5-2.64s2.57,3.66,3.24,3.92c.36.14.44-1,.68-2.14.08-5.51.37-16,1.4-20.47,1.42-6.27,3.14-17.48,2.29-21.31,0,0,7.09-7.82,7.85-34.95l-20.22-.25-.34,27.4s-5.71,7.12-3.64,21.3C256.23,406.32,257.12,417.71,257.5,423.26Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.37,442.18s-3.9-3.52-7.57-3.4",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.48,387.93a16.22,16.22,0,0,0-1,12.34c2.16,7.22-1.31,15.49,3.37,18.47s17.5,1.56,13.82-9.27-2.3-17.77-6.62-20.3S285.48,387.93,285.48,387.93Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.78,321.71,292,322.88l-9.48,7.27s-.65,12.9,3.51,21.44l2.36,8.29A22.91,22.91,0,0,0,287,370c.37,6.07,1.89,10.81,0,15.95a15.28,15.28,0,0,0-.88,6.22,3.74,3.74,0,0,1,.57,1.17c.81,2.62,2.22-2.68,5.67-2.29s1.76,3.07,2.54,3.11c2-5.95,11.51-34.8,7.58-42.33,0,0,6.4-6.95,8.1-15.44A19.89,19.89,0,0,0,307.78,321.71Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.74,217s5.89-7.16.66-11.58c0,0-3-13.35-12.22-10.2s-8.12,5.47-8.12,5.47-10.32.35-9.47,5.93,2.79,5.12,2.79,5.12-2.8,1.29-1.77,5.54,5.64,3.9,5.64,3.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.61,254.44a71.94,71.94,0,0,1,7.36,4.81s-.38,3.36,5.1,9.33,8,17.28,8,17.28c-2.79,4.9-2.22,5.48-2.44,9.18s-1.29,5.94-.53,8.48,3.24,1.05,3.24,1.05c3.37,0,5.37-6.32,5.37-6.32s1.74-9.6-1.13-22.61a95.72,95.72,0,0,0-7.81-22.25s-5.9-7-8.14-9.12c-2.71-2.51-11.74-9-11.74-9L312.32,253A44.21,44.21,0,0,1,317.61,254.44Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316,255l-.27,1.45a40.89,40.89,0,0,0,3.52-8.92,16.42,16.42,0,0,0-.65-10.37c-.62-1.38-2.37-3.45-3.64-1.74a51,51,0,0,1,1.54,13.07A52.69,52.69,0,0,1,316,255Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.29,257.25l.43-.84h0L316,255a52.69,52.69,0,0,0,.5-6.51A51,51,0,0,0,315,235.37a.61.61,0,0,0,0,.06c-.84,1.21.67,4.84.85,6.1a43.34,43.34,0,0,1,.24,8C315.9,251.57,316.23,255.41,315.29,257.25Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.32,259.27s3.7,1.11,5.44-3.53",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.16,291.15a16,16,0,0,0-1.4,4.36c-.37,2.35-1.05,4.82-3.23,3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.79,317.09s-5.07,10-5.13,32.73c0,0,7.6,3.24,14.82.19s9.66.35,9.66.35l1.22-7.63s-.69-16.86,13.9-15.55,12.62,14.54,12.62,14.54,7-18.56,1.68-26.49S261.79,317.09,261.79,317.09Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.66,327.27c-1,2.62-1.66,6.65-1.06,12.74",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.77,322.79a5.34,5.34,0,0,0-1.46,1.41",
    style: {
      fill: "none",
      stroke: "#7f7f7f",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,235.37a.15.15,0,0,1,0-.06c-24.95-10.27-45.93,2.2-52.67,7,2.77.58,5.58,3,7.24,6.77,3.48,7.93,1.28,12.91-.71,19a24.27,24.27,0,0,0-3.78-16.2c-1.08-1.62-2.62-3.24-4.45-3.56l3.12,24.28-4.62,46.45s1.92,7.66,24.25.3,29.2.37,29.2.37l-2.43-21.61a46,46,0,0,1,.46-13.45l5.17-28.28h0L316,255a52.69,52.69,0,0,0,.5-6.51A51,51,0,0,0,315,235.37Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.15,313.92c1.29-3.51,4.46-6.06,7.92-7.48a41.11,41.11,0,0,1,11-2.26,36.64,36.64,0,0,0-16.27-3.32c-1.39,0-3,.09-3.95-.9a3.32,3.32,0,0,1-.17-3.91,10.81,10.81,0,0,1,3-2.89,60.7,60.7,0,0,0,19.22-24.65A64.88,64.88,0,0,1,283,289.38q2.83-7.19,5.68-14.39l-15.39,14.15a1.67,1.67,0,0,1-1.23.6c-.74-.1-1-1.06-1-1.81a52.11,52.11,0,0,1,3.36-19.69,7.57,7.57,0,0,0,.74-3.4,2.35,2.35,0,0,0-2.25-2.24,14.85,14.85,0,0,0,2.18-7.45l-3.25,2.25c0,3.31-1,6.25-2.09,9.43q-.24.71-.48,1.44a.5.5,0,0,1-.58.33.67.67,0,0,1-.15-.06c0,.26-.05.52-.08.78-.66,5.18-2.25,10.18-3.62,15.22q-1.93,7.15-3.27,14.44l-2,19.86a6,6,0,0,0,.28.7c.06.1.13.17.19.27a5.09,5.09,0,0,0,1.44,1.11c2.71,1.44,8.66,2.27,21.66-2,7.65-2.53,13.51-3.3,17.92-3.22l.32-.07A66.4,66.4,0,0,0,284.15,313.92Z",
    style: {
      fill: "#00FF00",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.33,267.82a64.91,64.91,0,0,1-40.73,36.57",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.32,303.28a53.27,53.27,0,0,0-37.55,4.3",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.78,250a20.35,20.35,0,0,1-5.41,16.16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.48,243.22a26.9,26.9,0,0,1,4.67,16",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.14,229.66s-.79,13,7.31,13.11c10.33.13,9.9-11.67,9.9-11.67Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.05,216.21s-.54,11.5,1.27,14.53,6.87,7.44,10.84,7.49,9-5.38,9.28-7.55.21-16.58.21-16.58-.44-11.3-9-11.41S280.06,209.37,280.05,216.21Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.67,217.35a2.07,2.07,0,0,1,1.74-.26c1.33.45,1.87,2.39,1.2,4.32a3.68,3.68,0,0,1-3,2.75C301.67,221.81,301.67,219.28,301.67,217.35Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.14,217.32c0,.69-.37,1.25-.82,1.24s-.79-.57-.78-1.26.37-1.26.82-1.25S288.15,216.62,288.14,217.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.34,228.32a16.79,16.79,0,0,1-.31,4.08v0c0,.08,0,.16-.06.25a3.31,3.31,0,0,1-.59,1.13l0,0a2.33,2.33,0,0,1-2.22.9,2.4,2.4,0,0,1-1.61-1.47l0,0v0a4.66,4.66,0,0,1-.4-1.56,2,2,0,0,1,0-.34,6,6,0,0,1,.4-2.59Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.47,228.72l4.27.13s.55-.18.51-.64a.85.85,0,0,0-.11-.3l0-.06a2.41,2.41,0,0,0-1-.76,6,6,0,0,0-1.74-.16,2.35,2.35,0,0,0-.42.15A3,3,0,0,0,290.47,228.72Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.1,231.54s0,0,0,0,0-.2.14-.15,1.71,1.46,2.52,1.52c2.25,0,2-1.3,2-1.27a1,1,0,0,1,.27.68,2,2,0,0,1-.65,1.4l0,0a2.51,2.51,0,0,1-.89.58,2.54,2.54,0,0,1-2.23-.39,2.86,2.86,0,0,1-.72-.79,2,2,0,0,1-.44-1.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.22,217.23c0,.7-.38,1.26-.82,1.25s-.79-.57-.79-1.27.38-1.25.82-1.25S297.23,216.54,297.22,217.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.33,214.58s2.67-2.3,4.72-1.18",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.91,214.53s-2.6-2.38-4.69-1.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.34,261.76c-1.81,7.07-3.92,17.64-3.92,17.64l8.17-7s3.25-8.7,6.15-11.28c1.11-1,2.16-6.64,3.67-5.95s.53,4.2.53,4.2a16.05,16.05,0,0,1,3.09,1c1,.51,3.44,9.93,2.25,10.76s-2.5-2.39-3.22,1.31-7.17,7-7.17,7-11,15-15.72,17.49-9.82,3.75-11.17-9.41a81,81,0,0,1,1.84-25.42s-2.82-14.41,5.17-18S272.33,254,270.34,261.76Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 261.3,
    y1: 284.06,
    x2: 266.92,
    y2: 278.84,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 280.36,
    y1: 261.67,
    x2: 285.18,
    y2: 259.4,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.74,263.2s1.76,2.92,4.66,3.32",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.4,279.85c.41.27.22.88-.06,1.27a24.31,24.31,0,0,1-1.66,2.1c-.63.7-.95,1-1.54.93s-2.21-1.14-4.65-4.64c-.78-1.12-1.56-4.28-.42-5.45s4.55-3.36,3.66-2.43C273,273.46,274,276.4,279.4,279.85Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.87,280.08h0a13.47,13.47,0,0,1-2.44-3.69c-.57-1,.06-1.61.69-2.26l1.29-1.17c1-.83,1.62-.86,1.94,0l.24.54a9.63,9.63,0,0,0,2,2.75l.39.42a1.17,1.17,0,0,1-.21,1.69l-2.26,2.15A1.15,1.15,0,0,1,271.87,280.08Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.9,279l-.67.27-.86-1.28.55-.54S270.41,278.23,270.9,279Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294,214.73s-.15,5.61,1.13,7.88c.73,1.28-.86,2.31-1.59,2.52s-3.46-.87-3.19-2.27",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.75px"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "301.65 214.1 298.09 206.7 294 207.37 286.7 206.07 283.56 209.18 281.94 209.93 280.01 217.21 278.04 211.57 278.89 205.37 286.77 200.62 293.46 198.65 300.1 203.57 302.36 209.05 303.33 211.6 301.65 214.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.5,225.83a7.48,7.48,0,0,1,2.5-4.35,5.38,5.38,0,0,1-1.13-3.75,20.56,20.56,0,0,0-.05-4,1.42,1.42,0,0,0-.41-.86c-.53-.44-1.39,0-1.63.64-.43,1.16.14,3.91.12,5.2A35.48,35.48,0,0,0,280.5,225.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11,223.87c.13,1.92.52,2.3,2.16,3.3a6.13,6.13,0,0,0,5.54.38,3.84,3.84,0,0,1,1.58-.5,7.77,7.77,0,0,1,1.82.65,3.09,3.09,0,0,0,3.33-1.56,5.18,5.18,0,0,0,.9-3c-.71,1.67-3.12,1.45-4.54.32.67.53-2.19,1.33-2.46,1.31-1-.07-1.6-.56-2.67-.52C287.31,224.36,285.87,226.11,284.11,223.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.59,216.37a2.41,2.41,0,0,1,2.42.85c0,1.28-.07,3.65,0,6.09a.91.91,0,0,1-.22.11c-1.34.42-2.92-.81-3.53-2.76S276.26,216.79,277.59,216.37Z",
    style: {
      fill: "#999",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.32,230.74c1.8,3,6.87,7.44,10.84,7.49,1.82,0,3.85-1.11,5.56-2.55a10.19,10.19,0,0,1-3.29,5.26,6.21,6.21,0,0,1-2.31.5c-3.92-.05-8.9-4.35-10.76-7.37a26.06,26.06,0,0,1-.24-3.76A4.28,4.28,0,0,0,281.32,230.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.58,419.3c-1.78.14-2.91,2.22-2.64,4a8,8,0,0,0,2.85,4.43,6.3,6.3,0,0,0,2.93,1.73,2.49,2.49,0,0,0,2.82-1.42,3.47,3.47,0,0,0,5.57-3.48,4,4,0,1,0-5-5.76C245.18,415.44,235.84,414.59,236.58,419.3Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.71,214.49c-1.4-1.38-4.35-1.11-6-.05a4.52,4.52,0,0,0-1.76,5.18,1.7,1.7,0,0,0-1.8.94,1.67,1.67,0,0,0,.52,2,3.22,3.22,0,0,0-1.05,5.73l-2.53.89a2.68,2.68,0,0,0,3,.55,1.47,1.47,0,0,0,2.55,1,1.31,1.31,0,0,0,2.22-.76,3.92,3.92,0,0,0,7-3.37c1.51-.71,2.33-1.35,2.21-3.62s-2.95-3.53-2.91-3.62C323.82,217.86,323.05,215.79,321.71,214.49Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.13,263.16c1.72-1.36,3.83-2.1,6.11,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284,266.06c1.54-1.33,3.67-2,5.81.11",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.94,268.9c1.41-1.15,4.28-1.78,5.47.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.93,294.54l-1.3,1.07",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.18,302.14c1.9-.1,4.12-.78,5-2.47a11.19,11.19,0,0,0,1.19-2.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.31,303.93c3.11-.4,5.8-1.8,6.9-4.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.29,345.73a4.84,4.84,0,0,1,1.84,3.38,19.45,19.45,0,0,0,.72,3.9,3.28,3.28,0,0,0,2.92,2.29",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.87,375.39a4.5,4.5,0,0,0,2.8,7.12",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.63,383.69a3.36,3.36,0,0,0,.59,3.14",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.54,350.9s-1.67,4.25-4.24,4.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.46,378.3s-.77,7.63-5.06,9.38",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCt);
export default __webpack_public_path__ + "static/media/CT.ef26e8e3fc18f17ab679086e1fc1a81d.svg";
export { ForwardRef as ReactComponent };